import cart from './cartReducer';
import header from './headerReducer';
import { currencyReducer } from './currencyReducer';
import { appBannerReducer } from './appBannerReducer';

export default {
    cart,
    currency: currencyReducer,
    appBanner: appBannerReducer,
    header,
};
